import { z } from "zod";

/**
 * The Statsig dynamic config that gates the routines and skills work: areas
 * and roles on the pages, "about my work", skill search. One config, not a
 * gate per feature, so a cohort turns on as a whole.
 *
 * `enabled` turns the work on. The other fields exist only for changes that
 * act on every agent turn, so one of them can be rolled back for a cohort that
 * keeps the rest: code checks `enabled && skillSearch`, never `skillSearch`
 * alone.
 */
export const ROUTINES_V2_CONFIG = "routines_v2";

export const routinesV2ConfigSchema = z.object({
  enabled: z.boolean(),
  // Defaults, so a dashboard value that sets only `enabled` still parses
  // rather than falling back to the default and turning the whole work off.
  skillSearch: z.boolean().default(true),
  aboutMyWork: z.boolean().default(true),
});

export type RoutinesV2Config = z.infer<typeof routinesV2ConfigSchema>;

/**
 * Off: an account that no rule matches does not have routines-v2. The other
 * fields come from the schema's defaults, so the two cannot drift. Frozen,
 * because every account without a rule gets this same object.
 */
export const DEFAULT_ROUTINES_V2_CONFIG: Readonly<RoutinesV2Config> = Object.freeze(
  routinesV2ConfigSchema.parse({ enabled: false }),
);
